export interface IUOMState {
    getUOMDetails : any;
    getUOMSuccessMessage : any;
    getUOMErrorMessage : any;
    getEditUOMSuccess : any;
    getEditUOMError : any;

}

export const initialUOMState : IUOMState =  {
    getUOMDetails : null,
    getUOMSuccessMessage : null,
    getUOMErrorMessage : null,
    getEditUOMSuccess : null,
    getEditUOMError : null,
}